import axios from 'util/axiosConfig';


export const fetchRisMipsAPI = async () => {
    return await axios.get(`/api/v1/admin/ris-with-mips`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const fetchAllRisAPI = async () => {
    return await axios.get(`/api/v1/admin/ris`)
        .then(function (response) {
            if (response.data) {
                return { success: true, ris: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}